// @flow

import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import styled from "styled-components";
import "./App.css";

import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

import RestrictedContainer from "../../shared/components/RestrictedContainer";
import Logo from "../../shared/components/Logo";

import HomePage from "./pages/Home";
import BlockerPage from "./pages/Blocker";
import PrivacyPage from "./pages/Privacy";
import TermsPage from "./pages/Terms";
import ContactPage from "./pages/Contact";
import NotFoundPage from "./pages/NotFound";

import withTracker from "./withTracker";

const HeaderRestrictedContainer = styled(RestrictedContainer)`
	align-items: center;
	color: #fff;
	display: flex;
	font-weight: bold;
	justify-content: space-between;
	height: 80px;
`;
const StyledLink = styled(Link)`
	color: inherit;
	text-decoration: none;
`;
const NavButton = styled(Button)`
	&& {
		color: inherit;
		font-weight: inherit;
		height: 100%;
	}
`;
const MainSection = styled.main`
	padding: 15px;
`;
const MainResrictedContainer = styled(RestrictedContainer)`
	align-items: center;
	display: flex;
	flex-direction: column;
`;
const MainHeader = styled.header`
	background-color: ${(props) => props.theme.primary_blue};
`;
const MainFooter = styled.footer`
	text-align: center;
`;
type Props = {};
type State = {};
class App extends Component<Props, State> {
	render() {
		return (
			<div className="App">
				<MainHeader>
					<HeaderRestrictedContainer>
						<StyledLink to="/">
							<Logo />
						</StyledLink>
						<div style={{ height: "100%" }}>
							<StyledLink to="/privacy">
								<NavButton>Privacy</NavButton>
							</StyledLink>
							<StyledLink to="/terms">
								<NavButton>Terms</NavButton>
							</StyledLink>
							<StyledLink to="/contact">
								<NavButton>Contact us</NavButton>
							</StyledLink>
						</div>
					</HeaderRestrictedContainer>
				</MainHeader>
				<MainSection>
					<MainResrictedContainer>
						<Switch>
							<Route exact path="/" component={withTracker(HomePage)} />
							<Route
								path="/blocker/:encoded_url"
								component={withTracker(BlockerPage)}
							/>
							<Route path="/privacy" component={withTracker(PrivacyPage)} />
							<Route path="/terms" component={withTracker(TermsPage)} />
							<Route path="/contact" component={withTracker(ContactPage)} />
							<Route component={withTracker(NotFoundPage)} />
						</Switch>
					</MainResrictedContainer>
				</MainSection>
				<MainFooter>© 2018 Focus 45</MainFooter>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js